<template>
  <div class="comp-wrapper">
    <Search />
    <FooterBar />
  </div>
</template>

<script>
import Search from "./Search";
import FooterBar from "../../components/FloatingFooter/FooterBar.vue";

export default {
  name: "SearchView",
  components: {
    Search,
    FooterBar,
  },
};
</script>